export default __webpack_public_path__ + "static/media/b-1.64c64476.png";